import { fullName } from "@Utils/utils"

const userInfos = (userData) => [
    {
        title: "Nom et prénom",
        description: fullName(userData?.firstName, userData?.lastName),
        onPress: () => {}
    },
    {
        title: "Âge",
        description: "(non renseigné)",
        onPress: () => {}
    }
]

const activities = (activity) => [
    {
        title: "Axe prioritaire de soin",
        description: activity?.priorityAxisCare ?? "",
        onPress: () => {},
        isPressable: true
    },
    {
        title: "Freins",
        description: activity?.freins ?? "",
        onPress: () => {},
        isPressable: true
    },
    {
        title: "Leviers",
        description: activity?.levers ?? "",
        onPress: () => {},
        isPressable: true
    },
    {
        title: "Attentes",
        description: activity?.expectations ?? "",
        onPress: () => {},
        isPressable: true
    },
    {
        title: "Motivation au changement",
        description: activity?.motivation ?? "",
        onPress: () => {},
        isPressable: false
    },
    {
        title: "Compétences",
        description: "",
        onPress: () => {},
        isPressable: false,
        isSkills: true,
        skills: activity?.conclusionSkills ?? []
    },
    {
        title: "Objectifs",
        description: "",
        onPress: () => {},
        isPressable: false,
        isGoals: true,
        goals: activity?.conclusionSkills?.map((skill) => skill?.goals) ?? []
    },
    {
        title: "Plan de soin",
        subtitle: "Informations supplémentaire",
        description: activity?.carePlan ?? "",
        onPress: () => {},
        isPressable: true
    }
]

const ProgramContentToValidate = (content) => [
    {
        title: "Ateliers",
        description: "",
        onPress: () => {},
        isWorkshops: true,
        workshops: content?.conclusionWorkshops ?? []
    },

    {
        title: "Contenus",
        description: "",
        onPress: () => {},
        articles: content?.conclusionVideos ?? []
    }
]

export { userInfos, activities, ProgramContentToValidate }
